module.exports = __webpack_public_path__ + "media/vraag_6_vraag.85abe204.mp3";